/** Constantes e helpers do módulo Jurídico (frontend). */



export const OFICIO_STATUS_LABEL = {

  recebido: 'Recebido',

  em_analise_ia: 'Em análise IA',

  distribuido: 'Distribuído',

  aguardando_retorno: 'Aguardando retorno',

  respondido_parcial: 'Respondido parcial',

  pronto_para_resposta: 'Pronto p/ resposta',

  respondido: 'Respondido',

  encerrado: 'Encerrado',

  atrasado: 'Atrasado',

};



export const OFICIO_STATUS_COLOR = {

  recebido: 'default',

  em_analise_ia: 'info',

  distribuido: 'primary',

  aguardando_retorno: 'warning',

  respondido_parcial: 'warning',

  pronto_para_resposta: 'secondary',

  respondido: 'success',

  encerrado: 'success',

  atrasado: 'error',

};



export const DEST_STATUS_LABEL = {

  pendente: 'Pendente',

  notificado: 'Notificado',

  respondido: 'Respondido',

  atrasado: 'Atrasado',

};



export const DEST_STATUS_COLOR = {

  pendente: 'default',

  notificado: 'info',

  respondido: 'success',

  atrasado: 'error',

};



export function formatDateBr(value) {

  if (!value) return '—';

  const d = new Date(String(value).slice(0, 10) + 'T12:00:00');

  if (Number.isNaN(d.getTime())) return String(value);

  return d.toLocaleDateString('pt-BR');

}



export function formatDateTimeBr(value) {

  if (!value) return '—';

  const d = new Date(value);

  if (Number.isNaN(d.getTime())) return String(value);

  return d.toLocaleString('pt-BR');

}


